import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const DEFAULT_CONFIG = {
  eventDate: "2026-10-23",
  liste: ["Lista Eclipsia", "Lista Iovino", "Lista Aracri-Avvisati"],
  soldOut: false,
  halloween: false,
  formBgImages: ["/assets/form-bg-12.jpg", "/assets/form-bg-10.jpg", "/assets/form-bg-3.jpg", "/assets/form-bg-6.jpg", "/assets/form-bg-4.jpg", "/assets/form-bg-9.jpg", "/assets/form-bg-1.jpg", "/assets/form-bg-5.jpg", "/assets/form-bg-2.jpg", "/assets/form-bg-7.jpg", "/assets/form-bg-11.jpg", "/assets/form-bg-8.jpg"],
  heroVideo: "/assets/hero.mp4",
  texts: {
    homeEyebrow: "Finally Friday — Ogni Venerdì d'Inverno",
    homeHeadline: "Riserva Il Tuo Posto Al Nostro Prossimo Evento",
    ctaLabel: "Prossimo Evento",
    tavoliLabel: "Per Tavoli Info",
    prenotaEyebrow: "Prenota il tuo posto",
    prenotaSubline: "Finally Friday — ogni venerdì d'inverno",
    successTitle: "Prenotazione Confermata",
    soldOutTitle: "Siamo al Completo",
  },
};

export const mediaUrl = (u) => (u && u.startsWith("/api/") ? `${process.env.REACT_APP_BACKEND_URL}${u}` : u);

export const SITE = {
  phones: [
    { label: "+39 349 831 1527", href: "tel:+393498311527" },
  ],
  instagram: "https://www.instagram.com/eclipsia.night/",
  instagramHandle: "@eclipsia.night",
  whatsappChannel: "https://whatsapp.com/channel/0029Vb9RXD0E50Ub2yn24G2y",
  email: "eclipsianights@gmail.com",
  video: "/assets/hero.mp4",
  poster: "/assets/poster.jpg",
  logo: "/assets/logo.png",
};

const MESI = [
  "Gennaio", "Febbraio", "Marzo", "Aprile", "Maggio", "Giugno",
  "Luglio", "Agosto", "Settembre", "Ottobre", "Novembre", "Dicembre",
];

export function formatDateIt(iso) {
  const d = new Date(`${iso}T00:00:00`);
  const dd = String(d.getDate()).padStart(2, "0");
  const mm = String(d.getMonth() + 1).padStart(2, "0");
  return { short: `${dd}/${mm}`, long: `${d.getDate()} ${MESI[d.getMonth()]}` };
}

export function apiError(err) {
  const detail = err?.response?.data?.detail;
  if (!detail) return "Qualcosa è andato storto. Riprova.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => e?.msg || "").filter(Boolean).join(" ");
  return String(detail);
}

export async function fetchConfig() {
  try {
    const { data } = await axios.get(`${API}/config`);
    return { ...DEFAULT_CONFIG, ...data, texts: { ...DEFAULT_CONFIG.texts, ...data.texts } };
  } catch {
    return DEFAULT_CONFIG;
  }
}

export function authHeaders() {
  const token = localStorage.getItem("eclipsia_admin_token");
  return token ? { Authorization: `Bearer ${token}` } : {};
}
